<template>
    <div style="background:#78143a">
        <div style="width:1400px; margin:0 auto; padding:10px 0; color:#fff;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}" style="color:#fff">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="l12common_ctrl_container l12common">

            <!-- board -->
            <div class="l12common_board">
                <div class="board-item-new" v-for="day in datas.board.oldresults?datas.board.oldresults:datas.board.results" :key="day">
                    <p class="dt">{{ day.day }}</p>
                    <template v-for="it in day.data">
                        <span class="board-item-span" :key="it.title">{{it.title}}：{{it.value}}</span>
                    </template>
                </div>
                <div class="tips">
                    <p v-for="t in datas.board.tips">{{ t }}</p>
                </div>
            </div>

            <!-- 表格 -->
            <div class="l12common_ctrl_tables" v-for="(it,index) in datas.results" :key="`table${index}`" >
                <div class="table_title">
                    <h2>{{ it.title }}</h2>
                </div>
                <DataTable :fields="it.thead" :datas="it.tbody" class="l12common_ctrl_table" :paging="false"  v-if="it.type=='table'"/>
                <div v-if="it.type=='pie'">
                    <div v-for="(mod, index) in it.data" :key="index" style="position:relative; width:50%; float:left; margin:0 0 30px 0;">
                        <h3 style="text-align:center; color:#fff;">{{mod.title}}</h3>
                        <div class="" style="position:absolute; top:180px; width:100%; text-align:center; color:#fff; font-size:16px">{{mod.text.title}}<br />{{mod.text.num}}</div>
                        <Chart :datas="mod.data" :conf="mod.chart" :fields="mod.fields" :height="350"/>
                        <table cellpadding="0" cellspacing="0" class="l12common_small_table">
                            <tr v-for="field in mod.fields" v-if="field.title" :key="field.id">
                            <th>{{field.title}}</th>
                            <td v-for="sub_val in mod.data">{{sub_val[field.id]}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="tips">
                    <p v-for="t in it.tips" :key="t">{{ t }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'l12index',
    props: ['parent', 'name'],
    components: {
        DataTable,
        Chart,
    },
    mounted(){
        this.getData()
    },
    data() {
        return {
            datas: {
                board: [],
                results: [],
            },
            timer: {
                normal: null
            }
        }
    },
    methods: {
        getData() {
            this.loading = true
            this.$service.query(this.queryId, {}).then((data)=>{
                data.results.forEach((result)=>{
                    if(result.type=='pie') {
                        result.data.forEach((chart)=>{
                            chart.fields = chart.config.fields
                            chart.fields.push({'id':'ratio', 'suffix':'%'})
                            chart.text = {title:chart.config.title, num:chart.config.num}
                            chart.chart = {
                                type: 'pie',
                                x: { id:chart.config.name },
                                y: { id:chart.config.y},
                                label: true,
                                legend: false,
                                color: ['#7d203f','#982149','#861239','#a7345a','#c13e6a','#c55178','#bd5f7f','#c77591','#bb7f93','#d29bad','#e0b6c4'],
                                other: {innerRadius:0.8, labelStyle:{textStyle:{fill:'#fff'}}}
                            }
                        })
                    }
                });
                this.datas = data
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less">
.l12common_ctrl_table {
    .ant-table {
        background:#374377;
        color:#fff;
    }
    .ant-table-thead {
        border:none;
    }
    .ant-table-thead > tr > th {
        background: #861239;
        color:#fff;
    }
    .ant-table-tbody > tr > td {
        border-color:#7982ad;
    }
    .ant-table-thead > tr > th .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
        color:#fff;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
        padding:5px 0;
    }
    .ant-table-tbody > tr:nth-child(2n) td{
        background:#0b143e;
    }
    .ant-table-tbody > tr:hover td{
        background:#861239;
    }
    .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
        padding: 5px 0px;
    }
}
</style>
<style lang="less" scoped>
@width:1500px;

// 刷新按钮动画
@keyframes scale {
    0% {
        transform: scale(1);
        opacity: .7
    }
    50% {
        transform: scale(1.5);
        opacity: 0
    }
    99% {
      transform: scale(1);
      opacity: 0
    }
    100% {
        transform: scale(1);
        opacity: .7
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg)
    }
}

.l12common_ctrl_container {
    min-height: 700px;
    .l12common_ctrl_content_container {
        width:@width;
        margin:0 auto;
    }
    .l12common_ctrl_title {
        height:100px;
        width:100%;
        margin:0 0 40px 0;
        .refresh_btn {
            position:absolute;
            left: 50%;
            margin:25px 0 0 250px;
            width: 50px;
            height: 50px;
            text-align: center;
            cursor: pointer;
            border-width: 0;
            background-color: transparent;
            color: rgba(0, 0, 0, .3);

            i {
                font-size: 25px;
                line-height: 55px;
            }
            &:hover {
                animation: spin 2s infinite linear;
            }
            &:hover:after {
                animation: none;
            }
            &:after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 50px;
                width: 50px;
                border-radius: 100%;
                border: 1px solid rgba(0, 0, 0, .3);
                animation: scale 2s ease infinite;
            }
        }
    }

    .l12common_ctrl_tables {
        margin:0 auto;
        margin-top:20px;
        margin-bottom:30px;
        width: @width;
        .table_title {
            position: relative;
            text-align: center;
            margin:50px 0 30px 0;
            h2 {
                color: #fff; 
                font-size:20px;
                &:before {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    left:0;
                    width:40%;
                    border-bottom: 1px solid #fff;
                }
                &:after {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    right:0;
                    width:40%;
                    border-bottom: 1px solid #fff;
                }
            }
        }
        .l12common_ctrl_table {
            .ant-table {
                background:#374377;
                color:#fff;
            }
            .ant-table-thead {
                border:none;
            }
            .ant-table-thead > tr > th {
                background: #861239;
                color:#fff;
            }
            .ant-table-tbody > tr > td {
                border-color:#7982ad;
            }
            .ant-table-thead > tr > th .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
                color:#fff;
            }
            .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
                padding:5px 0;
            }
            .ant-table-tbody > tr:nth-child(2n) td{
                background:#0b143e;
            }
            .ant-table-tbody > tr:hover td{
                background:#861239;
            }
            .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
                padding: 5px 0px;
            }
        }
        .l12common_small_table {
            width:90%;
            margin:0 auto;
            font-size:13px;
            text-align: center;
            tr > th {
                background: #861239;
                color:#fff;
                padding:5px 5px;
            }
            tr > td {
                background:#374377;
                color:#fff;
                border-color:#7982ad;
                padding:5px 5px;
            }
            tr:nth-child(2n) td{
                background:#0b143e;
            }
        }
        .tips { color: #8c9ac1; margin-top: 10px; text-align:center}
    }

    &.l12common {
        background: #151a40 url('../../../assets/img/ctrl/l12/bg.jpg') no-repeat;
        overflow:hidden;
    }

        
    .l12common_board {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        max-width: 1440px;
        margin: 200px auto 50px;
        padding: 70px 25px 30px;
        border: 10px solid #505698;
        background: rgba(32, 36, 84, 0.78);
        box-shadow: 0 0 30px #0b0c2f;
        &:before {
            content: "";
            position: absolute;
            width: 1200px;
            height: 135px;
            left: 0;
            margin-left: 20px;
            top: -80px;
            background: url(../../../assets/img/ctrl/l12/title.png) no-repeat;
            z-index: 1;
        }

        .board-item-new {
        width:160px;
        min-height:150px;
        margin: 0 5px 20px 5px;
        padding:0 0 20px 0;
        background:rgba(200,200,200,0.4);
        color: #777;
        position: relative;
        display: inline-block;
        .dt {
            width: 100%;
            height: 60px;
            margin-bottom: 20px;
            margin-left: 0;
            background-color: #ffffff;
            color: #3f4484;
            font-size: 18px;
            line-height: 60px;
            text-align: center;
        }
        p {
            margin-left: 15px;
            margin-right: 15px;
            line-height:24px;
            color:#3f4484;
        }
        }
        .board-item-span{line-height:24px; color:#fff; display:block; padding:0 15px;}
        .tips { color: #8c9ac1; margin-top: 10px; text-align:center; 
            p{margin:0}
        }
    }
}
</style>